import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export default {
  state: {
    link_manual: {
      th: process.env.MANUAL_URL_TH + '#sorting',
      en: process.env.MANUAL_URL_EN + '#sorting',
      vi: process.env.MANUAL_URL_VI + '#sorting'
    }
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sort_options/index.js